import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class DirectMailService {
  private readonly _componentName = 'DirectMailService';

  constructor() {}
}
